"use strict";

export default class CARROUSEL{
    constructor(configuration)
    {
        //configuration (should be an object)

        //catpure images
        const images = document.querySelectorAll('.imageGallery .image');
        this.imgContainerActive= null;

        //creat one mask
        const mask = document.createElement("div");
        mask.classList.add("mask");
        mask.style.display="none";
        mask.addEventListener("click",(event)=> { 
            this.ResetView(this.imgContainerActive);
        });
        document.body.appendChild(mask);
        this.mask =mask;

        //bind event
        for (const imageContainer of images) {
            Array.from(imageContainer.childNodes).find(n=>n.nodeName==="IMG");
            imageContainer.addEventListener("click",(event)=> {
                event.preventDefault();
                //console.log("clicked on imagecontainer");
                if(this.imgContainerActive)
                {
                   this.ResetView(this.imgContainerActive);
                }
                else
                {
                    imageContainer.classList.add("fullscreen");
                    mask.style.display="block";
                    this.imgContainerActive = imageContainer;
                }
                
            });
        }
        
    }
    ResetView(containerToReset)
    {
        containerToReset.classList.remove("fullscreen");
        this.mask.style.display="none";
        this.imgContainerActive=null;
    }
}